import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { Currency } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import {
  Totals,
  TotalsSection
} from "../../../../Invoices/components/Totals/Totals";
import { ClientPayableLineItem } from "../../types";

type Props = {
  amount: number;
  currency: Currency;
  lineItems: ClientPayableLineItem[];
};

// Presentational only — amount + line-item breakdown, driven purely by
// props so a future guest-flow sibling can feed it a differently-sourced
// ClientPayableView.
export const ClientPayableAmountSection: React.FC<Props> = props => {
  const sections: TotalsSection[] = [
    {
      items: props.lineItems.map(lineItem => [
        lineItem.description || "",
        formatMoney(lineItem.amount, props.currency)
      ])
    },
    {
      items: [
        {
          bold: true,
          left: "Total",
          right: formatMoney(props.amount, props.currency)
        }
      ]
    }
  ];

  return <Totals sections={sections} />;
};
